export function addOffsetToDate(date: Date): Date {
    const offset = date.getTimezoneOffset()
    date.setTime(date.getTime() + (offset * 60 * 1000))
    return date;
  }